import React from 'react';
import { Stack, Icon } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import '../css/controll/noDataFound.scss'
type NoDataFoundProps = {
  isShow: boolean
};

export const NoDataFound = ({ isShow }: NoDataFoundProps) => {
  const { t } = useTranslation();
  return (
    <>
      {(isShow) && (
        <Stack className={"no-data-found"} style={{marginTop: 12}}>
          {/* <Icon iconName="Inbox"></Icon> */}
          <img src="/images/box.png" width="75" />
          <div>{t("NoDataFound")}</div>
        </Stack>
      )}
    </>
  );
};

